import api from './axios';

export const cipApi = {
    // Analytics
    getDashboardMetrics: async () => {
        const response = await api.get('/cip/dashboard/kpis/');
        return response.data;
    },
    getTimetable: async () => {
        const response = await api.get('/cip/dashboard/timetable/');
        return response.data;
    },
    getTrends: async (params) => {
        return { message: "Frontend aggregation needed" };
    },

    // CIP Preparations (Pending/Approved)
    getPreparations: async (status) => {
        const response = await api.get(`/cip/preparations/`, { params: { status } });
        return response.data;
    },
    startPreparation: async (data) => {
        const response = await api.post('/cip/preparations/', data);
        return response.data;
    },
    updatePreparationStatus: async (id, statusData) => {
        const response = await api.patch(`/cip/preparations/${id}/`, statusData);
        return response.data;
    },

    // CIP Events (Ongoing/Unsuccessful)
    getEvents: async (status) => {
        const response = await api.get(`/cip/events/`, { params: { status } });
        return response.data;
    },
    supervisorVerify: async (id, data) => {
        const response = await api.post(`/cip/events/${id}/supervisor_verify/`, data);
        return response.data;
    },

    // Expired CIPs
    getExpiredLoops: async () => {
        const response = await api.get('/cip/expired-loops/');
        return response.data;
    },

    // CIP Loops Configuration
    getLoops: async () => {
        const response = await api.get('/cip/loops/');
        return response.data;
    },
    getLoop: async (id) => {
        const response = await api.get(`/cip/loops/${id}/`);
        return response.data;
    },
    createLoop: async (data) => {
        const response = await api.post('/cip/loops/', data);
        return response.data;
    },
    updateLoop: async (id, data) => {
        const response = await api.put(`/cip/loops/${id}/`, data);
        return response.data;
    },
    deleteLoop: async (id) => {
        const response = await api.delete(`/cip/loops/${id}/`);
        return response.data;
    },

    // CIP Attributes Configuration
    getAttributes: async (params) => {
        const response = await api.get('/cip/attributes/', { params });
        return response.data;
    },
    getAttribute: async (id) => {
        const response = await api.get(`/cip/attributes/${id}/`);
        return response.data;
    },
    createAttribute: async (data) => {
        const response = await api.post('/cip/attributes/', data);
        return response.data;
    },
    updateAttribute: async (id, data) => {
        const response = await api.put(`/cip/attributes/${id}/`, data);
        return response.data;
    },
    deleteAttribute: async (id) => {
        const response = await api.delete(`/cip/attributes/${id}/`);
        return response.data;
    },

    // CIP Measuring Units
    getMeasuringUnits: async (params) => {
        const response = await api.get('/cip/measuring-units/', { params });
        return response.data;
    },
    getMeasuringUnit: async (id) => {
        const response = await api.get(`/cip/measuring-units/${id}/`);
        return response.data;
    },
    createMeasuringUnit: async (data) => {
        const response = await api.post('/cip/measuring-units/', data);
        return response.data;
    },
    updateMeasuringUnit: async (id, data) => {
        const response = await api.put(`/cip/measuring-units/${id}/`, data);
        return response.data;
    },
    deleteMeasuringUnit: async (id) => {
        const response = await api.delete(`/cip/measuring-units/${id}/`);
        return response.data;
    },


    // Lookups
    getElements: async (params) => {
        const response = await api.get('/cip/elements/', { params });
        return response.data;
    },
    createElement: async (data) => {
        const response = await api.post('/cip/elements/', data);
        return response.data;
    },
    updateElement: async (id, data) => {
        const response = await api.put(`/cip/elements/${id}/`, data);
        return response.data;
    },
    deleteElement: async (id) => {
        const response = await api.delete(`/cip/elements/${id}/`);
        return response.data;
    },

    getUnits: async (params) => {
        const response = await api.get('/cip/units/', { params });
        return response.data;
    },
    createUnit: async (data) => {
        const response = await api.post('/cip/units/', data);
        return response.data;
    },
    updateUnit: async (id, data) => {
        const response = await api.put(`/cip/units/${id}/`, data);
        return response.data;
    },
    deleteUnit: async (id) => {
        const response = await api.delete(`/cip/units/${id}/`);
        return response.data;
    },

    getDepartments: async (params) => {
        const response = await api.get('/cip/departments/', { params });
        return response.data;
    },
    createDepartment: async (data) => {
        const response = await api.post('/cip/departments/', data);
        return response.data;
    },
    updateDepartment: async (id, data) => {
        const response = await api.put(`/cip/departments/${id}/`, data);
        return response.data;
    },
    deleteDepartment: async (id) => {
        const response = await api.delete(`/cip/departments/${id}/`);
        return response.data;
    },

    getSteps: async (params) => {
        const response = await api.get('/cip/steps/', { params });
        return response.data;
    },
    createStep: async (data) => {
        const response = await api.post('/cip/steps/', data);
        return response.data;
    },
    updateStep: async (id, data) => {
        const response = await api.put(`/cip/steps/${id}/`, data);
        return response.data;
    },
    deleteStep: async (id) => {
        const response = await api.delete(`/cip/steps/${id}/`);
        return response.data;
    },

    // Users and Roles
    getUsers: async () => {
        try {
            const response = await api.get('/core/users/');
            return response.data;
        } catch {
            return [];
        }
    },
    getRoles: async () => {
        return [];
    },

    // Activity Log
    getActivityLog: async (params) => {
        return [];
    },

    // Schedules
    getSchedules: async (params) => {
        const response = await api.get('/cip/schedules/', { params });
        return response.data;
    },
    createSchedule: async (data) => {
        const response = await api.post('/cip/schedules/', data);
        return response.data;
    },
    updateSchedule: async (id, data) => {
        const response = await api.put(`/cip/schedules/${id}/`, data);
        return response.data;
    },
    deleteSchedule: async (id) => {
        const response = await api.delete(`/cip/schedules/${id}/`);
        return response.data;
    }
};

export default cipApi;
